// src/services/mentorService.ts

import api from './api';
import type { User } from '../types/user';

/**
 * Service function to get a list of all students.
 * @returns A promise that resolves to an array of all User objects with the student role.
 */
export const getAllStudents = async (): Promise<User[]> => {
  try {
    // This correctly calls the GET /api/mentor/students route
    const response = await api.get<User[]>('/mentor/students');
    return response.data;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to fetch students.');
  }
};

/**
 * Service function to approve a student account.
 * @param studentId - The ID of the student to approve.
 * @returns A promise that resolves with a success message.
 */
export const approveStudent = async (studentId: string): Promise<string> => {
  try {
    // ✅ FIX: Updated to the correct backend route
    const response = await api.patch<{ message: string }>(`/mentor/students/${studentId}/approve`);
    return response.data.message;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to approve student.');
  }
};

/**
 * Service function to reject (delete) a student account.
 * @param studentId - The ID of the student to reject and delete.
 * @returns A promise that resolves with a success message.
 */
export const rejectStudent = async (studentId: string): Promise<string> => {
  try {
    // ✅ FIX: Updated to the correct backend route for deleting a user
    const response = await api.delete<{ message: string }>(`/mentor/users/${studentId}`);
    return response.data.message;
  } catch (error: any) {
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error('Failed to reject student.');
  }
};

const mentorService = {
    getAllStudents,
    approveStudent,
    rejectStudent
};

export default mentorService;